import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await authApi.session(sessionId);
        setUser(data.user);
        // clear the fragment so refresh doesn't retry
        window.history.replaceState({}, document.title, "/dashboard");
        navigate(data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // surfaces only in dev; avoid leaking error details in prod logs
          // eslint-disable-next-line no-console
          console.error("auth exchange failed", e);
        }
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen aurora flex items-center justify-center">
      <div className="glass px-8 py-6 rounded-3xl flex items-center gap-3">
        <Sparkles className="animate-pulse text-neon-pink" />
        <span className="font-display text-lg">Signing you in…</span>
      </div>
    </div>
  );
}
